// extracted by mini-css-extract-plugin
export default {"Container":"ViewRecipe_Container__+75FJ","Message":"ViewRecipe_Message__8eqNk"};